// Default setValue options to prevent triggering validation, dirty, or touch states
// Used when programmatically setting form values (e.g., from templates or mode switches)
// To be used with react-hook-form's setValue() method
// Read more about setValue() options here: https://react-hook-form.com/docs/useform/setvalue
export const SET_VALUE_OPTIONS_NO_VALIDATION = {
  shouldDirty: false,
  shouldTouch: false,
  shouldValidate: false,
};
